class LocationSwitcher extends HTMLElement {
  static bound = false;

  constructor() {
    super();

    this.handleHashChange = this.handleHashChange.bind(this);
    this.handleAfterHide = this.handleAfterHide.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
  }

  static getPrimary() {
    return document.querySelector('location-switcher');
  }

  static getOpenModal() {
    return document.querySelector('[data-location-modal][open]');
  }

  static bindGlobalEvents() {
    if (LocationSwitcher.bound) return;
    LocationSwitcher.bound = true;

    window.addEventListener('hashchange', LocationSwitcher.handleHashChange);
    document.addEventListener('click', LocationSwitcher.handleLinkClick);
  }

  static unbindGlobalEvents() {
    if (!LocationSwitcher.bound) return;
    LocationSwitcher.bound = false;

    window.removeEventListener('hashchange', LocationSwitcher.handleHashChange);
    document.removeEventListener('click', LocationSwitcher.handleLinkClick);
  }

  static handleHashChange() {
    const instance = LocationSwitcher.getPrimary();
    if (!instance) return;
    instance.handleHashChange();
  }

  static handleLinkClick(event) {
    const instance = LocationSwitcher.getPrimary();
    if (!instance) return;
    instance.handleLinkClick(event);
  }

  connectedCallback() {
    if (this.dataset.locationSwitcherInitialized === 'true') return;
    this.dataset.locationSwitcherInitialized = 'true';

    this.modal = this.querySelector('[data-location-modal]');
    if (!this.modal) return;

    LocationSwitcher.bindGlobalEvents();
    this.modal.addEventListener('modal:afterHide', this.handleAfterHide);

    if (LocationSwitcher.getPrimary() === this) {
      this.handleHashChange();
    }
  }

  disconnectedCallback() {
    this.modal?.removeEventListener('modal:afterHide', this.handleAfterHide);

    if (!document.querySelector('location-switcher')) {
      LocationSwitcher.unbindGlobalEvents();
    }
  }

  get hash() {
    return this.dataset.hash || '#location';
  }

  handleHashChange() {
    if (LocationSwitcher.getPrimary() !== this) return;
    if (window.location.hash !== this.hash) return;
    this.openModal();
  }

  handleAfterHide() {
    if (window.location.hash !== this.hash) return;
    const { pathname, search } = window.location;
    history.replaceState(null, document.title, `${pathname}${search}`);
  }

  handleLinkClick(event) {
    if (LocationSwitcher.getPrimary() !== this) return;
    const link = event.target.closest('a');
    if (!link) return;
    if (link.origin && link.origin !== window.location.origin) return;
    if (link.hash !== this.hash) return;

    event.preventDefault();

    if (window.location.hash !== this.hash) {
      window.location.hash = this.hash;
    } else {
      this.openModal();
    }
  }

  openModal() {
    if (!this.modal) return;
    if (this.modal.hasAttribute('open')) return;

    const openModal = LocationSwitcher.getOpenModal();
    if (openModal && openModal !== this.modal) return;

    if (typeof this.modal.show === 'function') {
      this.modal.show();
      return;
    }

    if (customElements.get('x-modal')) {
      this.modal.setAttribute('open', '');
      return;
    }

    customElements.whenDefined('x-modal').then(() => {
      if (typeof this.modal.show === 'function') {
        this.modal.show();
      } else {
        this.modal.setAttribute('open', '');
      }
    });
  }
}

if (!customElements.get('location-switcher')) {
  customElements.define('location-switcher', LocationSwitcher);
}
